import React, { useEffect, useState } from 'react'
import Breadcrumbs from "components/Common/Breadcrumb"
import {
    Button,
    Row,
    Col,
    Modal,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    FormGroup,
    FormFeedback
} from "reactstrap";
import { useFormik, FormikProvider } from "formik"
import * as Yup from "yup"
import GeneralCargoType from './components/GeneralCargoType';
import DgCargoType from './components/DgCargoType';
import OdcCargoType from './components/OdcCargoType';
import ReeferCargoType from './components/ReeferCargoType';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { addQuotesSeaExportGeneralCargo, getByIdQuotes } from 'store/actions';
import { useHistory, useParams } from 'react-router-dom';
import AirGeneralCargoType from './components/AirGeneralCargoType';
import AirDgCargoType from './components/AirDgCargoType';
import DatePicker from 'constants/DatePicker';
import moment from "moment";
import PdfView from 'components/Common/PdfView';
import uploadFIle from 'components/Common/Base64Convertion';
import Select, { createFilter } from "react-select";
import { exportType } from './../../constants/exportType';
import SelectSearch from 'react-select-search';
import { listForShipmentBy } from 'constants/ShipmentByList';
import { quotesFormResetFieldTouched } from 'constants/ResetFormField';
import PageLoader from 'components/Common/PageLoader';
import { portData }  from "../../constants/port"
import AsyncSelect from "react-select/async";

const QuotesRequest = () => {
    document.title = "Enquiry-Request | Glottis Logistics"
    let { id } = useParams()
    const [baseFileName, setBaseFileName] = useState('')
    const [previewPdf, setPreviewPdf] = useState(false)
    const [baseFile, setBaseFile] = useState("");
    const [selectedGroup, setselectedGroup] = useState("SEA")
    const [portLoadingValue, setPortLoadingValue] = useState({label: 'Select port.....', value:''})
    const [portDischargeValue, setPortDischargeValue] = useState({label: 'Select port.....', value:''})
    // const [preview, setPreview] = useState(false);    // we didn't confirm the quote preview need or not
    const [totalWeight, setTotalWeight] = useState()
    const [volume, setVolume] = useState()
    const dispatch = useDispatch()
    const history = useHistory()
    const [submittedDraft, setSubmitedDrafts] = useState()
    const [quoteData, setQuoteData] = useState()
    const { quote, updateQuotes, getQuotes } = useSelector(state => ({
        quote: state.GetQuoteById.quote,
        updateQuotes: state.AddQuotesSeaExportGeneralCargo,
        getQuotes: state.GetQuoteById
    }), shallowEqual)
    const getQuoteData = () => {
        dispatch(getByIdQuotes(id))
    }
    useEffect(() => {
        if (id) {
            getQuoteData()
        }
    }, [id])
    useEffect(() => {
        setQuoteData(quote?.quote)
    }, [quote])
    useEffect(() => {
    }, [quoteData])

    // Form validation
    const quotesForm = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            shipmentBy: 'SEA',
            shipmentType: 'EXPORT',
            portOfLoading: "",
            postOfDischarge: "",
            commodity: "",
            cargoType: 'GENERAL',
            cargoReadyDate: '',
            container: [{
                noOfContainer: '',
                weightPerCargo: '',
                containerType: '',
                containerSize: '',
                length: '',
                width: '',
                height: '',
                weight: '',
                humidity: '',
                temperature: '',
                ventilation: '',
                packageType: '',
                netWeight: '',
            }],
            imoDGGlass: '',
            unNumber: '',
            packageCode: '',
            msdsCertificate: '',
        },
        validationSchema: Yup.object({
            portOfLoading: Yup.string().required("Port of loading is required"),
            postOfDischarge: Yup.string().required("Port of discharge is required").test("sameValueCheck", "Port of loading and port of discharge should not be same", val => quotesForm?.values?.portOfLoading !== val),
            commodity: Yup.string().required("Commodity is required").max(250, 'Commodity should not exceed 250 characters'),
            cargoType: Yup.string().required("Select a cargo type"),
            cargoReadyDate: Yup.date().required("Select a date").min(new Date(), 'Choose a future date').typeError('Select a date'),
            imoDGGlass: Yup.string().when("cargoType",
                {
                    is: (value) => {
                        return value === "DG"
                    },
                    then: Yup.string().required('Imo DG class is required').max(20, 'IMO DG class should not exceed 20 characters')
                }
            ),
            unNumber: Yup.string().when("cargoType",
                {
                    is: (value) => {
                        return ((quotesForm.values.shipmentBy === 'SEA') && (value === "DG"))
                    },
                    then: Yup.string().required('UN number is required').max(20, 'UN number should not exceed 20 characters')
                }
            ),
            packageCode: Yup.string().when("cargoType",
                {
                    is: (value) => {
                        return ((quotesForm.values.shipmentBy === 'SEA') && (value === "DG"))
                    },
                    then: Yup.string().required('Package code is required').max(20, 'Package code should not exceed 20 characters')
                }
            ),
            msdsCertificate: Yup.mixed()
                .when("cargoType",
                    {
                        is: (value) => {
                            return (value === "DG" && baseFile === '')
                        },
                        then: Yup.mixed().required('Choose a file')
                    }
                )
                .when("cargoType",
                    {
                        is: (value) => {
                            return (value === "DG" && baseFile !== '')
                        },
                        then: Yup.mixed()
                    }
                ),
            container: Yup.array()
                .when("cargoType",
                    {
                        is: (value) => {
                            return ((quotesForm.values.shipmentBy === 'SEA') && (value === "GENERAL"))
                        },
                        then: Yup.array().of(Yup.object().shape({
                            weightPerCargo: Yup.string().required('Gross weight is required').max(8, 'Gross weight should not exceed 8 characters'),
                            netWeight: Yup.string().required('Net weight is required').max(8, 'Net weight should not exceed 8 characters'),
                            containerType: Yup.string().required('Container type is required'),
                            containerSize: Yup.string().required('Container size is required'),
                            noOfContainer: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value !== 'LCL')
                                    },
                                    then: Yup.string().required('No of container is required').max(3, 'Number of container should not exceed 3 characters')
                                }
                            ),
                            length: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value === 'LCL')
                                    },
                                    then: Yup.string().required('Length is required').max(7, 'Length should not exceed 7 characters')
                                }
                            ),
                            width: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value === 'LCL')
                                    },
                                    then: Yup.string().required('Width is required').max(7, 'Width should not exceed 7 characters')
                                }
                            ),
                            height: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value === 'LCL')
                                    },
                                    then: Yup.string().required('Height is required').max(7, 'Height should not exceed 7 characters')
                                }
                            ),
                            // weight: Yup.string().when("containerType",
                            //     {
                            //         is: (value) => {
                            //             return (value === 'LCL')
                            //         },
                            //         then: Yup.string().required('Weight is required')
                            //     }
                            // ),
                        }))
                    }
                )
                .when("cargoType",
                    {
                        is: (value) => {
                            return ((quotesForm.values.shipmentBy === 'SEA') && (value === "DG"))
                        },
                        then: Yup.array().of(Yup.object().shape({
                            weightPerCargo: Yup.string().required('Gross weight is required').max(8, 'Gross weight should not exceed 8 characters'),
                            netWeight: Yup.string().required('Net weight is required').max(8, 'Net weight should not exceed 8 characters'),
                            containerType: Yup.string().required('Container type is required'),
                            containerSize: Yup.string().required('Container size is required'),
                            noOfContainer: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value !== 'LCL')
                                    },
                                    then: Yup.string().required('No of container is required').max(3, 'Number of container should not exceed 3 characters')
                                }
                            ),
                            length: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value === 'LCL')
                                    },
                                    then: Yup.string().required('Length is required').max(7, 'Length should not exceed 7 characteres')
                                }
                            ),
                            width: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value === 'LCL')
                                    },
                                    then: Yup.string().required('Width is required').max(7, 'Width should not exceed 7 characteres')
                                }
                            ),
                            height: Yup.string().when("containerType",
                                {
                                    is: (value) => {
                                        return (value === 'LCL')
                                    },
                                    then: Yup.string().required('Height is required').max(7, 'Height should not exceed 7 characteres')
                                }
                            ),
                            // weight: Yup.string().when("containerType",
                            //     {
                            //         is: (value) => {
                            //             return (value === 'LCL')
                            //         },
                            //         then: Yup.string().required('Weight is required')
                            //     }
                            // ),
                        }))
                    }
                )
                .when("cargoType",
                    {
                        is: (value) => {
                            return ((quotesForm.values.shipmentBy === 'SEA') && (value === "ODC"))
                        },
                        then: Yup.array().of(Yup.object().shape({
                            weightPerCargo: Yup.string().required('Gross weight is required').max(8, 'Gross weight should not exceed 8 characters'),
                            netWeight: Yup.string().required('Net weight is required').max(8, 'Net weight should not exceed 8 characters'),
                            containerType: Yup.string().required('Container type is required'),
                            containerSize: Yup.string().required('Container size is required'),
                            length: Yup.string().required('Length is required').max(7, 'Length should not exceed 7 characters'),
                            width: Yup.string().required('Width is required').max(7, 'Width should not exceed 7 characters'),
                            height: Yup.string().required('Height is required').max(7, 'Height should not exceed 7 characters'),
                            // weight: Yup.string().required('Weight is required')
                        }))
                    }
                )
                .when("cargoType",
                    {
                        is: (value) => {
                            return ((quotesForm.values.shipmentBy === 'SEA') && (value === "REEFER"))
                        },
                        then: Yup.array().of(Yup.object().shape({
                            weightPerCargo: Yup.string().required('Gross weight is required').max(8, 'Gross weight should not exceed 8 characters'),
                            netWeight: Yup.string().required('Net weight is required').max(8, 'Net weight should not exceed 8 characters'),
                            containerType: Yup.string().required('Container type is required'),
                            containerSize: Yup.string().required('Container size is required'),
                            temperature: Yup.string().required('Temperature is required').max(6, 'Temperature should not exceed 6 characters'),
                            humidity: Yup.string().required('Humidity is required').max(6, 'Humidity should not exceed 6 characters'),
                            ventilation: Yup.string().required('Ventilation is required').max(6, 'Ventilation should not exceed 6 characters')
                        }))
                    }
                )
                .when("cargoType",
                    {
                        is: (value) => {
                            return ((quotesForm.values.shipmentBy === 'AIR') && ((value === "GENERAL") || (value === "DG")))
                        },
                        then: Yup.array().of(Yup.object().shape({
                            // weightPerCargo: Yup.string().required('Gross weight is required'),
                            packageType: Yup.string().required('Package type is required').max(30, 'Package type should not exceed 30 characters'),
                            length: Yup.string().required('Length is required').max(7, 'Length should not exceed 7 characters'),
                            width: Yup.string().required('Width is required').max(7, 'Width should not exceed 7 characters'),
                            height: Yup.string().required('Height is required').max(7, 'Height should not exceed 7 characters'),
                            weight: Yup.string().required('Weight is required').max(7, 'Weight should not exceed 7 characters'),
                            noOfContainer: Yup.string().required('Quantity is required').max(3, 'Number of package should not exceed 3 characters')
                        }))
                    }
                )
        }),
        onSubmit: values => {
            let container = values.container
            let data = {}
            data["shipmentBy"] = values.shipmentBy
            data["shipmentType"] = values.shipmentType
            data["commodity"] = values.commodity
            data["cargoType"] = values.cargoType
            data["portOfLoading"] = values.portOfLoading
            data["postOfDischarge"] = values.postOfDischarge
            data["container"] = container
            data['cargoReadyDate'] = values.cargoReadyDate
            if (values.cargoType === 'DG' || values.cargoType === 'REEFER') {
                data['imoDGGlass'] = values.imoDGGlass
                data['unNumber'] = values.unNumber
                data['packageCode'] = values.packageCode
                data['msdsCertificate'] = baseFile
            }
            if ((id !== undefined) || (id !== '')) {
                data['quoteId'] = id
            }
            data['quoteStatus'] = submittedDraft
            dispatch(addQuotesSeaExportGeneralCargo(data, history))
        },
    })

    // sum of array values
    useEffect(() => {
        //total volume
        const sumOfVolume = (quotesForm.values.container.reduce((a, v) => a = a + parseInt(v.length) * parseInt(v.width) * parseInt(v.height), 0))
        setVolume(sumOfVolume * 1000)
        //totalweight
        const sumOfWeight = (quotesForm.values.container.reduce((a, v) => a = a + parseInt(v.weight) * parseInt(v.noOfContainer), 0))
        setTotalWeight(sumOfWeight)
    }, [quotesForm])
    useEffect(() => {
        setFormValues()
    }, [quoteData])
    const setFormValues = () => {
        if (id && quote) {
            setShipmentByValue(quoteData?.shipmentBy)
            quotesForm.setFieldValue("shipmentType", quoteData?.shipmentType)
            setPortLoading(quoteData?.portOfLoading)
            setPortDischarge(quoteData?.postOfDischarge)
            quotesForm.setFieldValue("commodity", quoteData?.commodity)
            quotesForm.setFieldValue("cargoReadyDate", moment(quoteData?.cargoReadyDate).format('MM/DD/YYYY'))
            quotesForm.setFieldValue("cargoType", quoteData?.cargoType)
            quoteData?.container?.map((item, index) => {
                quotesForm.setFieldValue(`container.${index}.noOfContainer`, item.noOfContainer)
                quotesForm.setFieldValue(`container.${index}.weightPerCargo`, item.weightPerCargo)
                quotesForm.setFieldValue(`container.${index}.containerType`, item.containerType)
                quotesForm.setFieldValue(`container.${index}.containerSize`, item.containerSize)
                quotesForm.setFieldValue(`container.${index}.length`, item.length)
                quotesForm.setFieldValue(`container.${index}.width`, item.width)
                quotesForm.setFieldValue(`container.${index}.height`, item.height)
                quotesForm.setFieldValue(`container.${index}.weight`, item.weight)
                quotesForm.setFieldValue(`container.${index}.humidity`, item.humidity)
                quotesForm.setFieldValue(`container.${index}.temperature`, item.temperature)
                quotesForm.setFieldValue(`container.${index}.ventilation`, item.ventilation)
                quotesForm.setFieldValue(`container.${index}.packageType`, item.packageType)
                quotesForm.setFieldValue(`container.${index}.netWeight`, item.netWeight)
            })
            quotesForm.setFieldValue('imoDGGlass', quoteData?.imoDGGlass)
            quotesForm.setFieldValue('unNumber', quoteData?.unNumber)
            quotesForm.setFieldValue('packageCode', quoteData?.packageCode)
            setBaseFile(quoteData?.msdsCertificate)
        }
    }

    const [addContainerValidationSet, setAddContainerValidationSet] = useState(false)
    useEffect(() => {
        let idx = quotesForm.values.container.length - 1
        if (quotesForm.values.shipmentBy === 'SEA') {
            if (
                quotesForm.values.container[idx].containerType &&
                quotesForm.values.container[idx].containerSize &&
                quotesForm.values.container[idx].netWeight &&
                (
                    quotesForm.values.container[idx].noOfContainer ||
                    (
                        quotesForm.values.container[idx].length &&
                        quotesForm.values.container[idx].width &&
                        quotesForm.values.container[idx].height &&
                        (
                            quotesForm.values.container[idx].weight ||
                            quotesForm.values.container[idx].weightPerCargo
                        )
                    ) ||
                    (
                        quotesForm.values.container[idx].temperature &&
                        quotesForm.values.container[idx].humidity &&
                        quotesForm.values.container[idx].ventilation
                    )
                )
            ) {
                setAddContainerValidationSet(true)
            } else {
                setAddContainerValidationSet(false)
            }
        } else if (quotesForm.values.shipmentBy === 'AIR') {
            if (
                quotesForm.values.container[idx].packageType &&
                quotesForm.values.container[idx].noOfContainer &&
                quotesForm.values.container[idx].length &&
                quotesForm.values.container[idx].width &&
                quotesForm.values.container[idx].height &&
                quotesForm.values.container[idx].weight
                // && quotesForm.values.container[idx].weightPerCargo
            ) {
                setAddContainerValidationSet(true)
            } else {
                setAddContainerValidationSet(false)
            }
        }
    }, [quotesForm.values.container])

    const validateAddContainer = (condition) => {
        const index = quotesForm.values.container.length - 1
        quotesForm.setFieldTouched(`container.${index}.containerType`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.containerSize`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.noOfContainer`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.length`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.width`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.height`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.weight`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.temperature`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.humidity`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.ventilation`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.packageType`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.weightPerCargo`, condition, condition)
        quotesForm.setFieldTouched(`container.${index}.netWeight`, condition, condition)
    }
    function setShipmentByValue(shipmentBy) {
        setselectedGroup(shipmentBy);
        quotesForm.setFieldValue("shipmentBy", shipmentBy);
    }
    const shipmentByList = listForShipmentBy && listForShipmentBy?.map((shipmentBy) => ({
        name: shipmentBy.name,
        value: shipmentBy.value,
    }));
    const ResetContainer = () => {
        quotesForm.values.container = [{
            noOfContainer: '',
            weightPerCargo: '',
            containerType: '',
            containerSize: '',
            length: '',
            width: '',
            height: '',
            weight: '',
            humidity: '',
            temperature: '',
            ventilation: '',
            packageType: '',
            netWeight: '',
        }]
        validateAddContainer(false)
    }

    const loadOptions = async (inputValue) => {
        if (inputValue) {
            return await portData.filter((r) => r?.label.toLowerCase().startsWith(inputValue.toLowerCase()));
        } else {
            return await portData.slice(0, 100);
        }
    };

    const setPortLoading =(data) => {
        let value = portData?.filter((item) => item?.value === data)
        if (value) setPortLoadingValue(value)
        else setPortLoadingValue({ label: 'Select port.....', value: '' })
        quotesForm.setFieldValue("portOfLoading", data)
    }

    const dischargeOptions = async (inputValue) => {
        if (inputValue) {
            return await portData.filter((r) => r?.label.toLowerCase().startsWith(inputValue.toLowerCase()));
        } else {
            return await portData.slice(0, 100);
        }
    };

    const setPortDischarge =(dischargeData) => {
        let value = portData?.filter((item) => item?.value === dischargeData)
        if (value) setPortDischargeValue(value)
        else setPortDischargeValue({ label: 'Select port.....', value: '' })
        quotesForm.setFieldValue("postOfDischarge", dischargeData)
    }
 
    return (
        <div className="page-content request-quotes">
            <div className="container-fluid">
                <Breadcrumbs title="Enquiries" dashurl="/Quotes" breadcrumbItem="Request an Enquiry" />
                <div className="checkout-tabs">
                    {/* <Card> */}
                    {/* <CardBody> */}
                    {updateQuotes.loading || getQuotes.loading ? <PageLoader /> : ""}
                    <FormikProvider value={quotesForm}>
                        <Form
                            className="needs-validation"
                            encType="multipart/form-data"
                            onSubmit={e => {
                                e.preventDefault()
                                quotesForm.handleSubmit()
                                return false
                            }}>

                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='8'>
                                            <Row>
                                                <Col md='6'>
                                                    <Row>
                                                        <Col md='5'>
                                                            <Label>Shipping Type<span>*</span></Label>
                                                            <div className={`position-relative`}>
                                                                <SelectSearch
                                                                    options={(shipmentByList)}
                                                                    search={true}
                                                                    placeholder="Select"
                                                                    name="shipmentBy"
                                                                    value={selectedGroup}
                                                                    onChange={(e) => {
                                                                        quotesForm.resetForm()
                                                                        setShipmentByValue(e)
                                                                    }}
                                                                    onBlur={quotesForm.handleBlur}
                                                                    invalid={
                                                                        quotesForm.touched.shipmentBy && quotesForm.errors.shipmentBy ? true : false
                                                                    }
                                                                />
                                                                <div className="select-down-arrow">
                                                                    <i className="bx bx-chevron-down"></i>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col md='7' className='shipment-type-radio'>
                                                            <div>
                                                                <Input
                                                                    checked={quotesForm.values.shipmentType === 'IMPORT' ? true : false}
                                                                    type="radio"
                                                                    id="IMPORT"
                                                                    name='shipmentType'
                                                                    className="form-check-input me-2"
                                                                    onChange={() => { }}
                                                                    onBlur={quotesForm.handleBlur}
                                                                    invalid={quotesForm.touched.shipmentType && quotesForm.errors.shipmentType ? true : false}
                                                                    value='IMPORT'
                                                                    onClick={() => quotesForm.setFieldValue("shipmentType", 'IMPORT')}
                                                                />
                                                                <Label for='IMPORT'>Import</Label>
                                                            </div>
                                                            <div>
                                                                <Input
                                                                    checked={quotesForm.values.shipmentType === 'EXPORT' ? true : false}
                                                                    type="radio"
                                                                    id="EXPORT"
                                                                    name='shipmentType'
                                                                    className="form-check-input me-2"
                                                                    onChange={() => { }}
                                                                    onBlur={quotesForm.handleBlur}
                                                                    invalid={quotesForm.touched.shipmentType && quotesForm.errors.shipmentType ? true : false}
                                                                    value='EXPORT'
                                                                    onClick={() => quotesForm.setFieldValue("shipmentType", 'EXPORT')}
                                                                />
                                                                <Label for='EXPORT'>Export</Label>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md='6'>
                                                    <FormGroup className={`mb-3 ${quotesForm.touched.cargoReadyDate && quotesForm.errors.cargoReadyDate ? 'role' : ''}`}>
                                                        <Label>Cargo ready date<span>*</span></Label>
                                                        <DatePicker
                                                            className='form-control select-search-input'
                                                            name="cargoReadyDate"
                                                            minDate={new Date()}
                                                            onChange={quotesForm.handleChange}
                                                            onBlur={quotesForm.handleBlur}
                                                            value={quotesForm.values.cargoReadyDate || ""}
                                                            invalid={quotesForm.touched.cargoReadyDate && quotesForm.errors.cargoReadyDate ? true : false}
                                                        />
                                                        {quotesForm.touched.cargoReadyDate &&
                                                            quotesForm.errors.cargoReadyDate ? (
                                                            <span className="role-error invalid-feedback">{quotesForm.errors.cargoReadyDate}</span>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md='6'>
                                                    <FormGroup className="mb-3">
                                                        <Label>Port of loading<span>*</span></Label> 
                                                        <div className={`position-relative drop-down ${quotesForm.touched.portOfLoading && quotesForm.errors.portOfLoading ? 'role' : ''}`}>
                                                            <AsyncSelect className='form-control' value={portLoadingValue} cacheOptions defaultOptions loadOptions={loadOptions} onChange={(value)=>{
                                                                setPortLoading(value?.value)
                                                            }}/>
                                                        </div>
                                                        {quotesForm.touched.portOfLoading && quotesForm.errors.portOfLoading ? (
                                                            <span className="role-error invalid-feedback">{quotesForm.errors.portOfLoading}</span>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col md='6'>
                                                    <FormGroup className="mb-3">
                                                        <Label>Port of discharge<span>*</span></Label>
                                                        <div className={`position-relative drop-down ${quotesForm.touched.postOfDischarge && quotesForm.errors.postOfDischarge ? 'role' : ''}`}>
                                                            <AsyncSelect className='form-control' value={portDischargeValue} cacheOptions defaultOptions loadOptions={dischargeOptions} onChange={(value)=>{
                                                                setPortDischarge(value?.value)
                                                            }}/>
                                                        </div>
                                                        {quotesForm.touched.postOfDischarge && quotesForm.errors.postOfDischarge ? (
                                                            <span className="role-error invalid-feedback">{quotesForm.errors.postOfDischarge}</span>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md="4">
                                            <Label>Commodity<span>*</span></Label>
                                            <Input
                                                name="commodity"
                                                type="textarea"
                                                className="form-control"
                                                onChange={quotesForm.handleChange}
                                                onBlur={quotesForm.handleBlur}
                                                value={quotesForm.values.commodity || ""}
                                                invalid={quotesForm.touched.commodity && quotesForm.errors.commodity ? true : false}
                                            />
                                            {quotesForm.touched.commodity &&
                                                quotesForm.errors.commodity ? (
                                                <FormFeedback type="invalid">
                                                    {quotesForm.errors.commodity}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className='cargoType w-100'>
                                <CardBody>
                                    <Label>Cargo Type<span>*</span></Label>
                                    <div className='cargotype-radio d-flex'>
                                        <div className='cargo-item me-5 mb-3'>
                                            <Input
                                                checked={quotesForm.values.cargoType === 'GENERAL' ? true : false}
                                                type="radio"
                                                id="CargoTypeGeneral"
                                                name='cargoType'
                                                className="form-check-input me-2"
                                                onChange={() => { }}
                                                onBlur={quotesForm.handleBlur}
                                                invalid={quotesForm.touched.cargoType && quotesForm.errors.cargoType ? true : false}
                                                value='GENERAL'
                                                onClick={() => {
                                                    if (quotesForm.values.cargoType !== 'GENERAL') {
                                                        ResetContainer()
                                                    }
                                                    quotesForm.setFieldValue('cargoType', 'GENERAL')
                                                }}
                                            />
                                            <Label
                                                className="form-check-label"
                                                htmlFor="CargoTypeGeneral"

                                            >
                                                GENERAL
                                            </Label>
                                        </div>
                                        <div className='cargo-item me-5 mb-3'>
                                            <Input
                                                checked={quotesForm.values.cargoType === 'DG' ? true : false}
                                                type="radio"
                                                id="CargoTypeDg"
                                                name='cargoType'
                                                className="form-check-input me-2"
                                                onChange={() => { }}
                                                onBlur={quotesForm.handleBlur}
                                                invalid={quotesForm.touched.cargoType && quotesForm.errors.cargoType ? true : false}
                                                value='DG'
                                                onClick={() => {
                                                    if (quotesForm.values.cargoType !== 'DG') {
                                                        ResetContainer()
                                                    }
                                                    quotesForm.setFieldValue('cargoType', 'DG')
                                                }}
                                            />
                                            <Label
                                                className="form-check-label"
                                                htmlFor="CargoTypeDg"
                                            >
                                                DG
                                            </Label>
                                        </div>
                                        {
                                            (quotesForm.values.shipmentBy === "SEA") &&
                                            <div className='cargo-item me-5 mb-3'>
                                                <Input
                                                    checked={quotesForm.values.cargoType === 'ODC' ? true : false}
                                                    type="radio"
                                                    id="CargoTypeOdc"
                                                    name='cargoType'
                                                    className="form-check-input me-2"
                                                    onChange={() => { }}
                                                    onBlur={quotesForm.handleBlur}
                                                    invalid={quotesForm.touched.cargoType && quotesForm.errors.cargoType ? true : false}
                                                    value='ODC'
                                                    onClick={() => {
                                                        if (quotesForm.values.cargoType !== 'ODC') {
                                                            ResetContainer()
                                                        }
                                                        quotesForm.setFieldValue('cargoType', 'ODC')
                                                    }}
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    htmlFor="CargoTypeOdc"
                                                >
                                                    ODC
                                                </Label>
                                            </div>
                                        }
                                        {
                                            (quotesForm.values.shipmentBy === "SEA") &&
                                            <div className='cargo-item me-5 mb-3'>
                                                <Input
                                                    checked={quotesForm.values.cargoType === 'REEFER' ? true : false}
                                                    type="radio"
                                                    id="CargoTypeReefer"
                                                    name='cargoType'
                                                    className="form-check-input me-2"
                                                    onChange={() => { }}
                                                    onBlur={quotesForm.handleBlur}
                                                    invalid={quotesForm.touched.cargoType && quotesForm.errors.cargoType ? true : false}
                                                    value='REEFER'
                                                    onClick={() => {
                                                        if (quotesForm.values.cargoType !== 'REEFER') {
                                                            ResetContainer()
                                                        }
                                                        quotesForm.setFieldValue('cargoType', 'REEFER')
                                                    }}
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    htmlFor="CargoTypeReefer"
                                                >
                                                    REEFER
                                                </Label>
                                            </div>
                                        }
                                    </div>
                                    <div>
                                        {(quotesForm.values.shipmentBy === 'SEA') ?
                                            <>
                                                {(quotesForm.values.cargoType === 'GENERAL') && <GeneralCargoType
                                                    quotesForm={quotesForm}
                                                    addContainerValidationSet={addContainerValidationSet}
                                                    validateAddContainer={validateAddContainer}
                                                />}
                                                {(quotesForm.values.cargoType === 'DG') && <DgCargoType
                                                    quotesForm={quotesForm}
                                                    addContainerValidationSet={addContainerValidationSet}
                                                    validateAddContainer={validateAddContainer}
                                                />}
                                                {(quotesForm.values.cargoType === 'ODC') && <OdcCargoType
                                                    quotesForm={quotesForm}
                                                    addContainerValidationSet={addContainerValidationSet}
                                                    validateAddContainer={validateAddContainer}
                                                />}
                                                {(quotesForm.values.cargoType === 'REEFER') && <ReeferCargoType
                                                    quotesForm={quotesForm}
                                                    addContainerValidationSet={addContainerValidationSet}
                                                    validateAddContainer={validateAddContainer}
                                                />}
                                            </> :
                                            <>
                                                {(quotesForm.values.cargoType === 'GENERAL') && <AirGeneralCargoType
                                                    quotesForm={quotesForm}
                                                    volume={volume}
                                                    totalWeight={totalWeight}
                                                    addContainerValidationSet={addContainerValidationSet}
                                                    validateAddContainer={validateAddContainer}
                                                />}
                                                {(quotesForm.values.cargoType === 'DG') && <AirDgCargoType
                                                    quotesForm={quotesForm}
                                                    volume={volume}
                                                    totalWeight={totalWeight}
                                                    addContainerValidationSet={addContainerValidationSet}
                                                    validateAddContainer={validateAddContainer}
                                                />}
                                            </>
                                        }
                                        {
                                            (quotesForm.values.cargoType === 'DG' || quotesForm.values.cargoType === 'REEFER') &&
                                            <>
                                                <h4>MSDS Info</h4>
                                                <Row className='my-4'>
                                                    <Col md="3">
                                                        <FormGroup className="mb-3">
                                                            <Label>Imo dg Class{quotesForm.values.cargoType === 'REEFER' ? null : <span>*</span>}</Label>
                                                            <Input
                                                                name="imoDGGlass"
                                                                type="text"
                                                                className="form-control"
                                                                onChange={quotesForm.handleChange}
                                                                onBlur={quotesForm.handleBlur}
                                                                value={quotesForm.values.imoDGGlass || ""}
                                                                invalid={quotesForm.touched.imoDGGlass && quotesForm.errors.imoDGGlass ? true : false}
                                                            />
                                                            {quotesForm.touched.imoDGGlass &&
                                                                quotesForm.errors.imoDGGlass ? (
                                                                <FormFeedback type="invalid">
                                                                    {quotesForm.errors.imoDGGlass}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </FormGroup>
                                                    </Col>
                                                    {
                                                        quotesForm.values.shipmentBy === 'SEA' &&
                                                        <>
                                                            <Col md="3">
                                                                <FormGroup className="mb-3">
                                                                    <Label>UN number{quotesForm.values.cargoType === 'REEFER' ? null : <span>*</span>}</Label>
                                                                    <Input
                                                                        name="unNumber"
                                                                        type="text"
                                                                        className="form-control"
                                                                        onChange={quotesForm.handleChange}
                                                                        onBlur={quotesForm.handleBlur}
                                                                        value={quotesForm.values.unNumber || ""}
                                                                        invalid={quotesForm.touched.unNumber && quotesForm.errors.unNumber ? true : false}
                                                                    />
                                                                    {quotesForm.touched.unNumber &&
                                                                        quotesForm.errors.unNumber ? (
                                                                        <FormFeedback type="invalid">
                                                                            {quotesForm.errors.unNumber}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup> </Col>
                                                            <Col md="3">
                                                                <FormGroup className="mb-3">
                                                                    <Label>Package code{quotesForm.values.cargoType === 'REEFER' ? null : <span>*</span>}</Label>
                                                                    <Input
                                                                        name="packageCode"
                                                                        type="text"
                                                                        className="form-control"
                                                                        onChange={quotesForm.handleChange}
                                                                        onBlur={quotesForm.handleBlur}
                                                                        value={quotesForm.values.packageCode || ""}
                                                                        invalid={quotesForm.touched.packageCode && quotesForm.errors.packageCode ? true : false}
                                                                    />
                                                                    {quotesForm.touched.packageCode &&
                                                                        quotesForm.errors.packageCode ? (
                                                                        <FormFeedback type="invalid">
                                                                            {quotesForm.errors.packageCode}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup></Col>
                                                        </>
                                                    }
                                                    <Col md="3">
                                                        <FormGroup className={`mb-3 field-upload ${baseFile ? "upload" : ""}`}>
                                                            <Label>MSDS certificate{quotesForm.values.cargoType === 'REEFER' ? null : <span>*</span>}</Label>
                                                            <Input
                                                                id='UploadMSDS'
                                                                name="msdsCertificate"
                                                                type="file"
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    quotesForm.setFieldValue("msdsCertificate", e.target.value)
                                                                    uploadFIle(e, setBaseFile)
                                                                    if (e) {
                                                                        setBaseFileName(e.target.files[0].name)
                                                                    }
                                                                }}
                                                                onBlur={quotesForm.handleBlur}
                                                                accept=".pdf"
                                                                value={quotesForm.values.msdsCertificate || ""}
                                                                invalid={quotesForm.touched.msdsCertificate && quotesForm.errors.msdsCertificate ? true : false}
                                                            />
                                                            <Label htmlFor='UploadMSDS' className={`upload-field field-input ${quotesForm.touched.msdsCertificate &&
                                                                quotesForm.errors.msdsCertificate ? "is-invalid" : ""}`}><span>+</span><p className='mb-0'>Upload</p></Label>

                                                            {quotesForm.touched.msdsCertificate &&
                                                                quotesForm.errors.msdsCertificate ? (
                                                                <FormFeedback type="invalid">
                                                                    {quotesForm.errors.msdsCertificate}
                                                                </FormFeedback>
                                                            ) : null}
                                                            <div className={`upload-field view-file ${baseFile !== '' && baseFile !== undefined ? "" : 'd-none'}`} >
                                                                <div className='d-flex' onClick={() => setPreviewPdf(true)}>
                                                                    <i className='bx bxs-file-pdf h2 mb-0'></i>
                                                                    <p className='mb-0'>{baseFileName || 'MSDS certificate'}</p>
                                                                </div>
                                                                <i className='mdi mdi-close h2 mb-0' onClick={() => { setBaseFile(''); quotesForm.setFieldValue("msdsCertificate", null) }}></i>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        }
                                        {/* Modal for view pdf */}
                                        <PdfView preview={previewPdf} setPreview={setPreviewPdf} baseFile={baseFile} />
                                    </div>
                                </CardBody>
                            </Card>
                            <Row className='quotes-button-class justify-content-center mb-5'>
                                <Col className='text-center'>
                                    <Button className='primary-button' type="submit" onClick={() => setSubmitedDrafts('submitted')}>
                                        Submit to Admin
                                    </Button>
                                    {!id ? <Button className='btn btn-draft' type="submit" onClick={() => setSubmitedDrafts('draft')}>
                                        Save as Draft
                                    </Button> : null}
                                    <Button className="secountry-btn" type="reset" onClick={() => {
                                        if (id) {
                                            setFormValues()
                                            quotesFormResetFieldTouched(false, quotesForm, validateAddContainer)
                                        } else {
                                            quotesForm.resetForm()
                                            setselectedGroup('SEA')
                                            setPortLoadingValue({label: 'Select port.....', value:''})
                                            setPortDischargeValue({label: 'Select port.....', value:''})
                                        }
                                    }}> Clear </Button>

                                    {/* Preview data don't delete */}
                                    {/* <Modal
                                                isOpen={preview}
                                                toggle={() => {
                                                    setPreview(!preview);
                                                }}
                                                backdrop={'static'}
                                                id="staticBackdrop"
                                                scrollable={true}
                                            >
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="staticBackdropLabel">Preview</h5>
                                                    <button type="button" className="btn-close"
                                                        onClick={() => {
                                                            setPreview(false);
                                                        }} aria-label="Close"></button>
                                                </div>
                                                <div className="modal-body">
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            shipmentBy   :
                                                        </Col>
                                                        <Col sm={8}>{shipmentBy}</Col>
                                                    </Row>
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            shipmentType   :
                                                        </Col>
                                                        <Col sm={8}>{shipmentType}</Col>
                                                    </Row>
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            portOfLoading   :
                                                        </Col>
                                                        <Col sm={8}>{quotesForm.values.portOfLoading}</Col>
                                                    </Row>
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            postOfDischarge   :
                                                        </Col>
                                                        <Col sm={8}>{quotesForm.values.postOfDischarge}</Col>
                                                    </Row>
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            commodity   :
                                                        </Col>
                                                        <Col sm={8}>{quotesForm.values.commodity}</Col>
                                                    </Row>
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            cargoType   :
                                                        </Col>
                                                        <Col sm={8}>{quotesForm.values.cargoType}</Col>
                                                    </Row>
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            cargoReadyDate   :
                                                        </Col>
                                                        <Col sm={8}>{moment(quotesForm.values.cargoReadyDate).format("DD-MM-yyyy")}</Col>
                                                    </Row>
                                                    {
                                                        (quotesForm.values.cargoType === 'DG') &&
                                                        <>
                                                            <Row className='mb-4'>
                                                                <Col sm={4}>
                                                                    Imo DG Glass   :
                                                                </Col>
                                                                <Col sm={8}>{quotesForm.values.imoDGGlass}</Col>
                                                            </Row>
                                                            {(shipmentBy === "SEA") &&
                                                                <>
                                                                    <Row className='mb-4'>
                                                                        <Col sm={4}>
                                                                            UN number   :
                                                                        </Col>
                                                                        <Col sm={8}>{quotesForm.values.unNumber}</Col>
                                                                    </Row>
                                                                    <Row className='mb-4'>
                                                                        <Col sm={4}>
                                                                            Package code   :
                                                                        </Col>
                                                                        <Col sm={8}>{quotesForm.values.packageCode}</Col>
                                                                    </Row>
                                                                </>
                                                            }
                                                            <Row className='mb-4'>
                                                                <Col sm={4}>
                                                                    MSDS certificate   :
                                                                </Col>
                                                                <Col sm={8}>{quotesForm.values.msdsCertificate}</Col>
                                                            </Row>
                                                        </>
                                                    }
                                                    <Row className='mb-4'>
                                                        <Col sm={4}>
                                                            container   :
                                                        </Col>
                                                        <Col sm={8}>{quotesForm?.values?.container.map((item, index) => (
                                                            (shipmentBy === 'SEA') ?
                                                                <div key={index}>
                                                                    <h6><u>Container details-{index + 1}</u></h6>
                                                                    <p>Container type   :  {item.containerType}</p>
                                                                    <p>Container size   :  {item.containerSize}</p>
                                                                    {
                                                                        ((quotesForm.values.cargoType === 'GENERAL') || (quotesForm.values.cargoType === 'DG')) ?
                                                                            <p>No of container   :  {item.noOfContainer}</p> :
                                                                            (quotesForm.values.cargoType === 'ODC') ?
                                                                                <>
                                                                                    <p>Length   :   {item.length}</p>
                                                                                    <p>Width   :   {item.width}</p>
                                                                                    <p>Height   :   {item.height}</p>
                                                                                    <p>Weight   :   {item.weight}</p>
                                                                                </> :
                                                                                (quotesForm.values.cargoType === 'REEFER') &&
                                                                                <>
                                                                                    <p>Temperature :   {item.temperature}</p>
                                                                                    <p>Humidity :   {item.humidity}</p>
                                                                                    <p>Ventilation :   {item.ventilation}</p>
                                                                                </>
                                                                    }
                                                                    <p>Weight per cargo   :  {item.weightPerCargo}</p>
                                                                </div> :
                                                                <div key={index}>
                                                                    <h6><u>Package details-{index + 1}</u></h6>
                                                                    <p>Package type   :  {item.packageType}</p>
                                                                    <p>Length   :  {item.length}</p>
                                                                    <p>Width   :  {item.width}</p>
                                                                    <p>Height   :  {item.height}</p>
                                                                    <p>Weight   :  {item.weight}</p>
                                                                    <p>No of container   :  {item.noOfContainer}</p>

                                                                </div>
                                                        ))}
                                                            {
                                                                (shipmentBy === 'AIR') &&
                                                                <>
                                                                    <Row className='mt-5'>
                                                                        <Col sm={6}>
                                                                            Total volume   :
                                                                        </Col>
                                                                        <Col sm={6}>{(volume > 0) ? volume : 0} M³</Col>
                                                                    </Row>
                                                                    <Row className='my-4'>
                                                                        <Col sm={6}>
                                                                            Total weight   :
                                                                        </Col>
                                                                        <Col sm={6}>{(totalWeight > 0) ? totalWeight : 0} KG</Col>
                                                                    </Row>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-success" onClick={() => {
                                                        setPreview(false);
                                                    }}>OK</button>
                                                </div>
                                            </Modal> */}
                                </Col>
                            </Row>
                        </Form>
                    </FormikProvider>
                    {/* </CardBody> */}
                    {/* </Card> */}
                </div>
            </div>
        </div >
    )
}

export default QuotesRequest
